import Api from "../../../services/Api";

const BASE_URL = "/service/iqevse-csms/featureGating/v1";

export const featureGatingApi = {
  getAllFeatures: async () => {
    const response = await Api.get(`${BASE_URL}/getAllFeatures`);
    return response;
  },

  getFeatureById: async featureId => {
    const response = await Api.get(`${BASE_URL}/${featureId}`);
    return response;
  },

  createOrUpdateFeature: async (featureName, featureData) => {
    const response = await Api.post(`${BASE_URL}/${featureName}`, featureData);
    return response;
  },

  updateGatingStatus: async (featureId, gated) => {
    const response = await Api.put(`${BASE_URL}/${featureId}/gate`, gated);
    return response;
  },

  updateFeatureUsers: async (featureId, usersData) => {
    const response = await Api.put(`${BASE_URL}/${featureId}/users`, usersData);
    return response;
  },

  deleteFeature: async featureId => {
    const response = await Api.delete(`${BASE_URL}/${featureId}`);
    return response;
  },
};
